import loadingGif from '@/assets/gif/loading.gif';
import { LoaderWrapper, LoadingImage } from '@/components/LoaderAnimation/LoaderAnimation styles';

export const LoaderAnimation = () => {
  return (
    <LoaderWrapper>
      <LoadingImage src={loadingGif} alt="Loading..." />
    </LoaderWrapper>
  );
};
